import styled from 'styled-components'

export const Wrapper = styled.div`
  padding-top: 64px;

  .aga-input-area {
    min-height: 101px;
  }
`
